module.exports = __webpack_public_path__ + "img/steps-img.5ba72df6.png";